// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 4AX8GGLfZVNNUpcFCPJfPE
// Component: dAJ2OMT9u3Tw
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { NavigationBar } from "@plasmicpkgs/plasmic-nav";
import TextInput from "../../TextInput"; // plasmic-import: BqnTtwqsqFk/component
import Submit from "../../Submit"; // plasmic-import: zuTshuEKQv/component
import { useScreenVariants as useScreenVariantsuzHfTuP52Hu } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: uzHFTu_p5-2hu/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_blank_project.module.css"; // plasmic-import: 4AX8GGLfZVNNUpcFCPJfPE/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: dAJ2OMT9u3Tw/css
import screenShot20240710At10220PMpngSIuo6PHgnp7M from "../adelle_website/images/screenShot20240710At10220PMpng.png"; // plasmic-import: sIUO6PHgnp7m/picture
import georgepng56F9Unr5H from "../adelle_website/images/georgepng.png"; // plasmic-import: 56F9unr5h/picture

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array();

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "name.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "email.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "message.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsuzHfTuP52Hu()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"parent"}
          data-plasmic-override={overrides.parent}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.parent
          )}
          id={"work"}
        >
          <div
            data-plasmic-name={"homePage"}
            data-plasmic-override={overrides.homePage}
            className={classNames(projectcss.all, sty.homePage)}
          >
            <NavigationBar
              data-plasmic-name={"navigationBar"}
              data-plasmic-override={overrides.navigationBar}
              brand={
                <PlasmicLink__
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    sty.link__pd2J
                  )}
                  href={"#"}
                  platform={"react"}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__nPrL)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__t2CJv
                      )}
                    >
                      {"ADELLE GOETEMANN"}
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__o5Oq
                      )}
                    >
                      {"Freelance UX/UI Designer\nProduct Specialist"}
                    </div>
                  </div>
                </PlasmicLink__>
              }
              className={classNames("__wab_instance", sty.navigationBar)}
              closeButton={
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__wPyU0)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  src={"https://static1.plasmic.app/close.svg"}
                />
              }
              itemsGap={8}
              menuItems={
                <React.Fragment>
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__eUIsQ
                    )}
                    href={"#bio"}
                    platform={"react"}
                  >
                    {"ABOUT"}
                  </PlasmicLink__>
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__swElq
                    )}
                    href={"#projects"}
                    platform={"react"}
                  >
                    {"WORK"}
                  </PlasmicLink__>
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__laq9U
                    )}
                    href={"#contact"}
                    platform={"react"}
                  >
                    {"CONTACT"}
                  </PlasmicLink__>
                </React.Fragment>
              }
              openButton={
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___0CmYh)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  src={"https://static1.plasmic.app/menu.svg"}
                />
              }
              responsiveBreakpoint={768}
            />

            <div className={classNames(projectcss.all, sty.freeBox__qDpgw)}>
              <div className={classNames(projectcss.all, sty.freeBox__iTmf4)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__oqqNq
                  )}
                >
                  {"Adelle Goetemann"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cOkxf
                  )}
                >
                  {"I solve business problems through design. "}
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"bio"}
            data-plasmic-override={overrides.bio}
            className={classNames(projectcss.all, sty.bio, "")}
            id={"bio"}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__sZbpG)}
            >
              <div className={classNames(projectcss.all, sty.column__pwl5)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___32TtK
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{"I am a "}</React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700 }}
                    >
                      {"designer"}
                    </span>
                    <React.Fragment>{" and "}</React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700 }}
                    >
                      {"product specialist "}
                    </span>
                    <React.Fragment>
                      {
                        "based out of Brooklyn.\n\nI spent a decade in hospitality because I enjoy crafting and enriching a sense of community in fast paced environments. \n\nI have a research background surrounding distinct regional narratives derived from anecdotal and data-driven evidence in modern and contemporary art contexts because I believe in the power of storytelling.\n\nI began design because I love puzzles and because first impressions are important and empowering. \n\nI use a trans-disciplinary approach to create engaging and intuitive user experiences that bring value to people's lives.\n\n"
                      }
                    </React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700 }}
                    >
                      {
                        "I provide start ups with solutions at the junction of business strategy and product."
                      }
                    </span>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.column___6Pd32)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___3Q8I)}
                  displayHeight={"590px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: screenShot20240710At10220PMpngSIuo6PHgnp7M,
                    fullWidth: 1180,
                    fullHeight: 1510,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </Stack__>
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__lkm6S)}
            id={""}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox___0BLr1)}
              id={"projects"}
            />
          </div>
          <div
            data-plasmic-name={"contactSection"}
            data-plasmic-override={overrides.contactSection}
            className={classNames(projectcss.all, sty.contactSection)}
            id={"contact"}
          >
            <div className={classNames(projectcss.all, sty.freeBox__ffZr8)}>
              <div className={classNames(projectcss.all, sty.columns___9HAer)}>
                <div className={classNames(projectcss.all, sty.column__niS1)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xWxCw
                    )}
                  >
                    {"Let's Get in Touch :)"}
                  </div>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___5Pyuu)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"30%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loading={"lazy"}
                    src={{
                      src: georgepng56F9Unr5H,
                      fullWidth: 1431,
                      fullHeight: 1431,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__z1Ldx
                    )}
                  >
                    {"Please reach out to see my work."}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column__kcFrf)}>
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__kpFpG)}
                  >
                    <TextInput
                      data-plasmic-name={"name"}
                      data-plasmic-override={overrides.name}
                      className={classNames("__wab_instance", sty.name)}
                      onChange={(...eventArgs) => {
                        generateStateOnChangeProp($state, ["name", "value"])(
                          (e => e.target?.value).apply(null, eventArgs)
                        );
                      }}
                      placeholder={"Name"}
                      value={
                        generateStateValueProp($state, ["name", "value"]) ?? ""
                      }
                    />

                    <TextInput
                      data-plasmic-name={"email"}
                      data-plasmic-override={overrides.email}
                      className={classNames("__wab_instance", sty.email)}
                      onChange={(...eventArgs) => {
                        generateStateOnChangeProp($state, ["email", "value"])(
                          (e => e.target?.value).apply(null, eventArgs)
                        );
                      }}
                      value={
                        generateStateValueProp($state, ["email", "value"]) ?? ""
                      }
                    />

                    <TextInput
                      data-plasmic-name={"message"}
                      data-plasmic-override={overrides.message}
                      className={classNames("__wab_instance", sty.message)}
                      onChange={(...eventArgs) => {
                        generateStateOnChangeProp($state, ["message", "value"])(
                          (e => e.target?.value).apply(null, eventArgs)
                        );
                      }}
                      placeholder={"Message"}
                      value={
                        generateStateValueProp($state, ["message", "value"]) ??
                        ""
                      }
                    />
                  </Stack__>
                  <Submit
                    data-plasmic-name={"submitButton"}
                    data-plasmic-override={overrides.submitButton}
                    className={classNames("__wab_instance", sty.submitButton)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames(projectcss.all, sty.footer)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__mWpag
              )}
            >
              {"Adelle Goetemann"}
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__moR7S)}
            >
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  projectcss.__wab_text,
                  sty.link__dCf9T
                )}
                href={"#bio"}
                platform={"react"}
              >
                {"ABOUT"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  projectcss.__wab_text,
                  sty.link__td3Gl
                )}
                href={"#projects"}
                platform={"react"}
              >
                {"WORK"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  projectcss.__wab_text,
                  sty.link__ioBHm
                )}
                href={"#contact"}
                platform={"react"}
              >
                {"CONTACT"}
              </PlasmicLink__>
            </Stack__>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  parent: [
    "parent",
    "homePage",
    "navigationBar",
    "bio",
    "contactSection",
    "name",
    "email",
    "message",
    "submitButton",
    "footer"
  ],

  homePage: ["homePage", "navigationBar"],
  navigationBar: ["navigationBar"],
  bio: ["bio"],
  contactSection: [
    "contactSection",
    "name",
    "email",
    "message",
    "submitButton"
  ],

  name: ["name"],
  email: ["email"],
  message: ["message"],
  submitButton: ["submitButton"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "parent") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("parent"),
  {
    // Helper components rendering sub-elements
    homePage: makeNodeComponent("homePage"),
    navigationBar: makeNodeComponent("navigationBar"),
    bio: makeNodeComponent("bio"),
    contactSection: makeNodeComponent("contactSection"),
    _name: makeNodeComponent("name"),
    email: makeNodeComponent("email"),
    message: makeNodeComponent("message"),
    submitButton: makeNodeComponent("submitButton"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
